import "core-js/modules/es6.regexp.replace";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PengDan from './PengDan.vue';
import PengDanAward from './PengDanAward.vue';
import SharePengDan from './SharePengDan.vue';
import PengDanAnimate from './PengDanAnimate.vue';
import service from '../../services/service';
import eventBus from '../../../../util/eventBus';
import { util } from '@tencent/vft-common';
import { mapState, mapGetters, mapActions } from 'vuex';
import { MasterType, PersonalCodeStatus, StarCodeStatus, EggType, PropertyBelong } from './util';
var Visible = {
  PengDan: 'PengDan',
  PengDanAward: 'PengDanAward',
  SharePengDan: 'SharePengDan',
  PengDanAnimate: 'PengDanAnimate'
};
var sessionKey = 'd2d-shareCode';
export default {
  components: {
    PengDan: PengDan,
    PengDanAward: PengDanAward,
    SharePengDan: SharePengDan,
    PengDanAnimate: PengDanAnimate
  },
  settingKey: '碰蛋浮层',
  setting: {
    蛋图片: {
      type: 'object',
      properties: {
        今天没蛋了戳: '//puep.qpic.cn/vupload/0/20181212_1544771825220_3p6ws3dyxw.png/0',
        休息蛋: '//puui.qpic.cn/vupload/0/1544588645042_o3d9okyfieo/0',
        哭泣蛋: '//puui.qpic.cn/vupload/0/1544588645044_xh7lildw2dj/0',
        问号蛋: '//puui.qpic.cn/vupload/0/1544794398096_0mm2yzc37faf/0'
      }
    }
  },
  data: function data() {
    return {
      shareCode: util.getUrlParam('shareCode'),
      Visible: Visible,
      visible: null,
      masterEggInfo: null,
      awardList: [],
      awardInfo: null,
      isFromPengDan: false,
      goodList: window.setting.奖品列表
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _this = this;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              eventBus.$on('peng', function (shareCode) {
                _this.shareCode = shareCode;

                _this.startPengDan();
              });
              this.shareCode = util.getUrlParam('shareCode');

              if (!(this.shareCode && sessionStorage.getItem(sessionKey) !== this.shareCode)) {
                _context.next = 6;
                break;
              }

              this.startPengDan();
              _context.next = 12;
              break;

            case 6:
              if (!this.isLogin) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return this.checkUnReadList();

            case 9:
              _context.next = 12;
              break;

            case 11:
              this.$store.commit('closeDialog', 'pendDanAward');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['userInfo', 'payVip', 'eggInfo', 'eggList']), {
    isStarEgg: function isStarEgg() {
      return this.masterEggInfo.master_type === MasterType.Star;
    },
    masterEggImg: function masterEggImg() {
      var _this2 = this;

      if (this.isStarEgg) {
        return this.masterEggInfo.eggs_pic;
      } else {
        var list = this.$store.state.eggList;
        list = list.filter(function (item) {
          return +item.type === _this2.masterEggInfo.eggs_type;
        });

        if (list.length === 0) {
          return '';
        } else {
          var index = (this.shareCode[0] || 'd').charCodeAt() % list.length;
          return list[index].image;
        }
      }
    },
    myEggImg: function myEggImg() {
      return this.$store.getters.egg && this.$store.getters.egg.image;
    }
  }),
  methods: _objectSpread({}, mapActions(['getEggInfo', 'getLeaderboardInfo', 'getStatisticData']), {
    getCurrentShareCodeUrl: function getCurrentShareCodeUrl() {
      if (util.getUrlParam('shareCode') && util.getUrlParam('shareCode') === this.shareCode) {
        return window.location.href;
      } else {
        var url = location.href;
        url = url.replace(/#.*$/, '');
        url = util.setUrlParam('shareCode', this.shareCode, url);
        return url;
      }
    },
    goToXuFei: function goToXuFei() {
      var sessionKey = 'd2d-shareCode';
      sessionStorage.setItem(sessionKey, '');

      if (!this.isLogin) {
        this._openLogin(this.getCurrentShareCodeUrl());

        return false;
      }

      this.rootOpenUrl('https://film.qq.com/vip/act/cy/AqsHNxBp.html?ptag=cnyegg1'); //        this.$refs.payButton.beforePay(true)

      return false;
    },
    startPengDan: function () {
      var _startPengDan = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isLogin) {
                  _context2.next = 29;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return service.getInfoByShareCode(this.shareCode);

              case 4:
                res = _context2.sent;
                this.masterEggInfo = res.data;

                if (!(res.ret === -11)) {
                  _context2.next = 10;
                  break;
                }

                this.$store.commit('saveLoginStatus', true);
                _context2.next = 15;
                break;

              case 10:
                if (!(res.ret !== 0)) {
                  _context2.next = 14;
                  break;
                }

                throw new Error(res.msg);

              case 14:
                if (this.isStarEgg && res.data.star_code_status === StarCodeStatus.NotStart) {
                  this.alert('该明星分享码尚未开始');
                } else if (this.isStarEgg && res.data.star_code_status === StarCodeStatus.Ended) {
                  this.alert('该明星分享码已结束');
                }

              case 15:
                if (!this.masterEggInfo.is_your_code) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 18;
                return this.checkUnReadList();

              case 18:
                _context2.next = 22;
                break;

              case 20:
                this.visible = Visible.PengDan;

                if (process.env.NODE_ENV === 'production') {
                  sessionStorage.setItem(sessionKey, this.shareCode);
                }

              case 22:
                _context2.next = 27;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](1);
                this.confirm({
                  msg: '获取碰蛋信息失败，请刷新页面重试!',
                  confirmText: '刷新',
                  confirm: function confirm() {
                    window.location.href = _this3.getCurrentShareCodeUrl();
                  }
                });

              case 27:
                _context2.next = 30;
                break;

              case 29:
                this._openLogin(this.getCurrentShareCodeUrl());

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 24]]);
      }));

      function startPengDan() {
        return _startPengDan.apply(this, arguments);
      }

      return startPengDan;
    }(),
    checkUnReadList: function () {
      var _checkUnReadList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var res, i, j, belong, k, l, propertyBelongChaneg;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                propertyBelongChaneg = function _ref(belong) {
                  if (belong === 1) {
                    return 2;
                  } else if (belong === 2) {
                    return 1;
                  } else {
                    return belong;
                  }
                };

                _context3.next = 3;
                return service.getUnReadAwardList();

              case 3:
                res = _context3.sent;

                //property_belong 两个奖池奖品归属
                //0 各自所有（无小捣蛋）
                //1 全归客人（客人是小捣蛋 或 主人是明星蛋）
                //2 全归主人（主人是小捣蛋）
                //3 双方交换（客人和主人都是小捣蛋）
                // myEggType 客人蛋的类型  0 普通蛋，1 yoo蛋, 2 普通小捣蛋, 3 yoo小捣蛋
                if (util.getUrlParam('test-award')) {
                  res.list = [];

                  for (i = 0; i < 2; i++) {
                    for (j = 0; j < 2; j++) {
                      belong = [[PropertyBelong.Normal, PropertyBelong.Guest], [PropertyBelong.Master, PropertyBelong.Exchange]][i][j];

                      for (k = 0; k < 2; k++) {
                        for (l = 0; l < 2; l++) {
                          res.list.push({
                            'property_belong': belong,
                            'friendsEggType': j + 1,
                            'friendsGoodsName': '0.66元现金红包',
                            'friendsGoodsUrl': 'https://puui.qpic.cn/vshpic/0/0A2834ED0A924CDAF29C90AEB1BDD2D91548333454/0',
                            'friendsLotteryResult': k,
                            'friendsName': 'aaa68',
                            'friendsType': 1,
                            'friendsUrl': 'https://thirdqq.qlogo.cn/g?b=sdk&k=27bTVuXKalnMtRQqGz25Ow&s=100&t=591',
                            'friendsGoodsDouble': j === 0 && k ? 1 : 0,
                            'lotteryTime': 1544495284,
                            'myEggType': i + 1,
                            'myGoodsName': 'JBL T280A耳机',
                            'myGoodsUrl': '//puui.qpic.cn/vshpic/0/8E84D8B38E5ED31210937D4E38FF06F71544411230/0',
                            'myLotteryResult': l,
                            'myGoodsDouble': 0
                          });
                        }
                      }
                    }
                  }
                } // 因为后台返回数据的原因，这里需要将全归客人和全归主人的标志，交换一下


                if (res.ret === 0 && res.list && res.list.length > 0) {
                  this.awardList = res.list.map(function (item) {
                    return {
                      property_belong: propertyBelongChaneg(item.property_belong),
                      my: {
                        result: item.myLotteryResult,
                        pic: item.myGoodsUrl,
                        type: 1,
                        headurl: _this4.userInfo.headurl,
                        name: _this4.userInfo.nick,
                        property_name: item.myGoodsName,
                        egg_type: item.myEggType,
                        property_double: item.myGoodsDouble
                      },
                      other: {
                        result: item.friendsLotteryResult,
                        type: item.friendsType,
                        pic: item.friendsGoodsUrl,
                        headurl: item.friendsUrl,
                        name: item.friendsName,
                        property_name: item.friendsGoodsName,
                        master_big_url: '',
                        // 未读消息列表不会有和明星碰蛋的消息
                        egg_type: item.friendsEggType,
                        property_double: item.friendsGoodsDouble
                      }
                    };
                  });
                  this.isFromPengDan = false;
                  this.visible = Visible.PengDanAward;
                } else {
                  this.$store.commit('closeDialog', 'pendDanAward');
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkUnReadList() {
        return _checkUnReadList.apply(this, arguments);
      }

      return checkUnReadList;
    }(),
    hide: function hide() {
      this.visible = false;
      this.$store.commit('closeDialog', 'pendDanAward');
    },
    pengSuccess: function pengSuccess(res) {
      this.awardInfo = {
        property_belong: res.property_belong,
        my: {
          result: res.guest_property_result,
          pic: res.guest_property_url,
          type: 1,
          headurl: this.userInfo.headurl,
          name: this.userInfo.nick,
          property_name: res.guest_property_name,
          egg_type: res.guest_eggs_type,
          property_double: res.guest_property_double
        },
        other: {
          result: res.master_property_result,
          type: this.masterEggInfo.master_type,
          pic: res.master_property_url,
          headurl: this.masterEggInfo.master_url,
          name: this.masterEggInfo.master_name,
          master_big_url: this.masterEggInfo.master_big_url,
          master_background_url: this.masterEggInfo.master_background_url,
          property_name: res.master_property_name,
          egg_type: res.master_eggs_type,
          property_double: res.master_property_double
        }
      };
      this.awardList = [this.awardInfo];
      this.isFromPengDan = true;
      this.visible = Visible.PengDanAnimate;
      this.refreshInfo();
    },
    animateSuccess: function animateSuccess() {
      this.visible = Visible.PengDanAward;
    },
    refreshInfo: function () {
      var _refreshInfo = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.getEggInfo();
                this.getLeaderboardInfo();
                this.getStatisticData();
                this.$root.$children[0].$refs.myRecord.getMyRecord(true);
                this.$root.$children[0].getMoney();
                _context4.next = 7;
                return this.getInfoByShareCode(this.shareCode);

              case 7:
                this.masterEggInfo = _context4.sent;

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refreshInfo() {
        return _refreshInfo.apply(this, arguments);
      }

      return refreshInfo;
    }(),
    share: function share(awardInfo) {
      this.awardInfo = awardInfo;
      this.visible = Visible.SharePengDan;
    },
    getInfoByShareCode: function () {
      var _getInfoByShareCode = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(shareCode) {
        var _this5 = this;

        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return service.getInfoByShareCode(shareCode);

              case 2:
                res = _context5.sent;

                if (!(res.ret === 0)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", res.data);

              case 7:
                if (!(res.ret === -1007)) {
                  _context5.next = 11;
                  break;
                }

                this.alert({
                  title: '商家活动已结束',
                  msg: '去福利社看看吧，更多精彩内容等着你哦~',
                  confirm: function confirm() {
                    _this5.rootOpenUrl('//film.qq.com/x/welfare/');
                  }
                });
                _context5.next = 12;
                break;

              case 11:
                throw new Error(res.msg);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getInfoByShareCode(_x) {
        return _getInfoByShareCode.apply(this, arguments);
      }

      return getInfoByShareCode;
    }()
  })
};